import { createSelector } from "reselect";
const analytic = (state: any) => state.analytics;
const globalState = (state: any) => {
  let analytics = state.analytics,
    merchant = state.merchant;
  return { analytics, merchant };
};
const merchantId = (state: any) => state.analytics.merchant_id;
const merchants = (state: any) => state.merchant;
const flyers = (state: any) => state.analytics_metric.flyers;
const selectedFlyerId = (state: any) => state.analytics_metric.selectedFlyerId;
const publications = (state: any) => state.analytics.publications;
const publicationIds = (state: any) => state.analytics.publication_ids;
const selectedPublicationId = (state: any) =>
  state.analytics_metric.selectedPublicationId;

export const isMerchantUSBased = createSelector(
  merchantId,
  merchants,
  (merchantId: number, merchants: any[]) => {
    //Temporary fix for cases where merchant list has yet to be loaded prior to referencing this flag
    //TODO: refactor to block metric requests until full list of merchants is available
    let merchant = merchants.find((merchant: any) => merchant.id == merchantId);
    return merchant ? merchant.us_based : false;
  }
);

export const selectedFlyer = createSelector(
  flyers,
  selectedFlyerId,
  (flyers: any[], selectedFlyerId: number) =>
    flyers.find((flyer: any) => flyer.flyer_id == selectedFlyerId)
);

export const selectedPublication = createSelector(
  publications,
  selectedPublicationId,
  (publications: any[], selectedPublicationId: number) =>
    publications.find(
      (publication: any) => publication.flyer_run_id == selectedPublicationId
    )
);

export const currentPublications = createSelector(
  publications,
  publicationIds,
  (publications: any[], publicationIds: number[]) =>
    publications.filter((publication: any) =>
      publicationIds.includes(publication.flyer_run_id)
    )
);



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/selectors.ts